export { QueryHelper };

/**
 * Helper relating to query strings
 */
let QueryHelper = {

    /**
     * Render random query string
     */
    rand() {
        let ideas = [ 
           "Flower girl dress", "Hello Kitty", "Pet blanket", "Dog shampoo", "Power tool", "Diamond ring ", "Sunglasses",
           "Levi jeans", "Men's jeans", "Women's jeans", "Baby shoes", "Pet costumes", "Adidas", "Opi", "Chanel", "Handbag",
           "Mp3 player", "LCD TV", "Guitar", "Digital camera", "Suitcase", "Children's book", "Basketball", "Car stereo",
           "Surveillance camera", "Stereo amplifier", "Outdoor furniture", "Electronic cigarette",
           "Tennis racquet", "Flash light", "Violin", "Tripod", "Computer monitor", "Eye shadow", "Fragrance" 
        ];
        return ideas[Math.floor(Math.random() * ideas.length)];
    }

}